module.exports = __webpack_public_path__ + "static/media/ic_finger_gray.e6d0eb2b.svg";